import { Injectable } from '@angular/core';
import { MechanicsService } from './mechanics.service';
import { HttpClient } from '@angular/common/http';
import { WOption } from '../interfaces';
import { offices } from '../imports/offices';
import { deepClone } from '../utils';

interface HardcodedLists {
	offices: WOption[];
	niceClass: WOption[];
}

@Injectable({
	providedIn: 'root'
})
export class OptionsListService {

	public hardcodedLists: HardcodedLists = {
		// STATIC LISTS - built in buildHardcodedLists()
		offices: [],
		niceClass: [],
	}

	/* 
		suggestions : empty at start. Is reused for everything with a suggestion list : brandName, viennaClass, niceClass, usDesignClass, etc.
		  w-select-many takes WOption[], but w-input-autocomplete takes string[]...
	*/

	public suggestions: WOption[] = []; // | string[]
	public dbInfoCache: any = {};
	public noSuggestions: boolean = false; // This is not the same as suggestions.length===0. It can be 0 at the beginning. But if it's 0 after a search, then this flag turns true.
	public what: string = ""; // storing the type of what we're looking for (niceClass, viennaClass, etc.)

	public componentId: number | null = null // Little hack to avoid opening all the suggestions drawers of all the same components on the page. I'm giving each one an ID

	constructor(public ms: MechanicsService,
		public http: HttpClient) {

		this.buildStuff()
	}

	buildStuff() {

		const l = `ols.buildStuff() - `

		// Dirty hack to wait for the translations to be loaded
		const intervalWaitForTranslations = setInterval(() => {
			// console.log(`${l}Waiting for translations...`);
			if (!this.ms.translations) return
			this.buildHardcodedLists()
			clearInterval(intervalWaitForTranslations)
		}, 100)
	}

	async buildHardcodedLists() {

		const l = `ols.buildHardcodedLists() - `

		/*
			Building the static autocomplete lists (countries, IP offices...)
			Non-static (suggested) lists are done on the fly (viennaClass, usDesignClass)
		*/

		try {

			this.hardcodedLists.offices = offices.map((cc: string): WOption => ({
				value: cc,
				label: "(" + cc + ") " + this.ms.translate("office." + cc),

				// I use the "info" field to build a searchable string, for instance "frinpi" for "(FR) INPI"
				info: (cc + this.ms.translate("office." + cc)).toLowerCase() // lowercase, for faster search/match
			}));

			// BUILDING NICE CLASS OPTIONS LIST
			this.hardcodedLists.niceClass = Object.keys(this.ms.translations["niceClass"])
				.filter(key => key !== "_void_")
				.map(key => ({
					value: key,
					label: key, // For Nice class, we only want "10" in labels and queryParams2Human, not the full blast description
					label2: key + " - " + this.ms.translations["niceClass"][key],// What is displayed in the suggestion list (full blast description)

					// I use the "info" field to build a searchable string, for instance "frinpi" for "(FR) INPI"
					info: (key + this.ms.translations["niceClass"][key]).toLowerCase(),
				})
				);
			// console.log(`${l}Built Nice list = `, this.hardcodedLists.niceClass)


			// console.log(`${l}Built hardcoded offices list = `, deepClone(this.hardcodedLists.offices))

		} catch (err) {

			// console.log(`${l}Caught error (couldn't fetch DbInfo): `, err)
		}

		// console.log(`${l}Have built this.hardcodedLists = `, this.hardcodedLists)
	}

	// what: applicant / representative / brandName
	suggest($event: KeyboardEvent, what: string, componentId?: number): void {

		const l: string = `OLS doSuggest() - `

		// console.log(`${l}$event.key = `, $event.key)
		// console.log(`${l}what = `, what);

		this.noSuggestions = false
		this.what = "" + what;
		this.componentId = componentId || null; // Little hack to avoid opening all the suggestions drawers of all the same components on the page. I'm giving each one an ID

		const word = (<HTMLInputElement>$event.target).value.trim()

		// console.log(`${l}word = `, word);

		if (what === "undefined"
			||
			["Enter", "ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown", "Space"].includes($event.key)
		) {
			return
		}

		if (!word?.length) {
			this.suggestions = []
			return
		}

		this.suggestHardcoded(word)
		return
	}

	suggestHardcoded(word: string) {

		const l = `ols.suggestHardcoded() - `

		// console.log(`${l}Suggesting from hardcoded list '${this.what}' = `, (this.hardcodedLists as any)[this.what]) // SHUT UP TYPESCRIPT!!

		word = word.toLowerCase();
		this.suggestions = ((this.hardcodedLists as any)[this.what] || []).filter((wOption: WOption) => (wOption.info || wOption.label2 || "").includes(word))

		// Set noSuggestions flag when search was performed but no results found
		this.noSuggestions = word.length > 0 && this.suggestions.length === 0;

		// console.log(`${l}this.suggestions = `, this.suggestions)
	}
}
